<template>
  <table style="width: 100%;height:100%">
    <tr>
      <td>
        <center><span class="label">{{ $t('totem.languageSelector').toUpperCase() }}</span></center>
      </td>
    </tr>
    <tr>
      <td>
        <center style="padding-bottom:10px;">
          <table>
            <tr>
              <td
                v-for="(item) in Languages"
                :key="item"
              >
                <a
                  @click="handleChangeLocale(item)"
                >
                  <div
                    class="main-language-item"
                  >
                    <div class="language-item">
                      {{item.toUpperCase()}}
                    </div>
                  </div>
                </a>
              </td>
            </tr>
          </table>
        </center>
      </td>
    </tr>
  </table>
</template>

<script>
import {
  mapState
} from 'vuex'
import i18n from '@/plugins/i18n'
import constants from '@/constants'
export default {
  computed: {
    ...mapState('app',['Languages', 'locale']),
    sidebarWidth() {
      return constants.totem.sidebar.width + 'px'
    },
    height() {
      return constants.totem.meteo.height + 'px'
    },
  },
  methods: {
    handleChangeLocale(locale) {
      i18n.locale = locale
    }
  }
}
</script>

<style scoped>
  .main-language-item {
    background: linear-gradient(300deg, rgba(0,0,0,.5), transparent);
    padding: 4px;
    border-radius: 100%;
    margin: 2px;
  }
  .language-item {
    border-radius: 100%;
    padding: 10px 12px 10px 12px;
    /* background-color: rgba(0, 0, 0, 0.31); */
    color: white;
    border: 0.5px solid rgba(0, 0, 0, 0.29);; 
    background-color: rgba(0,0,0,.31);
  }

  .meteo {
    background-color: rgba(0, 0, 0, .6);
    width: var(--sidebar-width);
    height: var(--height);
    border-radius: 0px 10px 10px 0px;
    mix-blend-mode: multiply;
  }
</style>
